import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { Button } from '@techsoftware/happay-widgets';
import { CustomDialog } from '../customComponent/customWidgets';
import Locales from '../../constants/locales';
const BankConstants = Locales.JSON.banks;

export const ChangeBankAccount = props => {
  const onClose = () => {
    props.onClose();
  };

  const onChange = () => {
    props.onChange();
  };

  const drawBankAccount = () =>
    ['Bank of America', 'Bank of India', 'SBI'].map(item => (
      <Grid
        title={item}
        className="pointer bordered-container active padding-30 margin-r-30 margin-b-20"
      >
        <div className="body dark fw-600">{item}</div>
        <div className="body margin-b-20">Acc. no. XXXXXXX</div>
        <div className="info-text margin-b-10">Withdrawable balance</div>
        <div className="section-heading primary-blue-color">$ 80,000</div>
      </Grid>
    ));

  return (
    <CustomDialog // not in use
      open={props.open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      className="bank-account"
      title={
        <div title="Bank account">
          {BankConstants.CHANGE_BANK}
          <div className="info-text margin-b-10">{BankConstants.BANK_STR}</div>
        </div>
      }
      crossIcon
      dividers
      actions={
        <>
          <Button
            type="button"
            size="small"
            text="Back"
            variant="secondary"
            // className="btn-small btn-secondary"
            onClick={onClose}
          />
          <Button
            type="button"
            text="Change"
            size="small"
            variant="primary"
            className="margin-l-10"
            onClick={onChange}
          />
        </>
      }
    >
      <Grid className="margin-t-10">
        <Grid container>{drawBankAccount()}</Grid>
      </Grid>
    </CustomDialog>
  );
};

ChangeBankAccount.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onChange: PropTypes.func,
};

ChangeBankAccount.defaultProps = {
  open: false,
  onClose: () => {},
  onChange: () => {},
};
